import React from 'react';
import { PopoverCard } from '../PopoverCard';
import UserSearchPanel from './UserSearchPanel';

/**
 * A search button that appears in the admin bar that toggles a popup search input + results dropdown.
 *
 * e.g.
 * <UserSearchButton />
 */
export default class UserSearchButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };

        this.handleKey = this.handleKey.bind(this);
        this.blur = this.blur.bind(this);
    }

    componentDidMount() {
        window.addEventListener('click', this.blur);
        window.addEventListener('keydown', this.handleKey);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.blur);
        window.removeEventListener('keydown', this.handleKey);
    }

    blur() {
        this.setState({
            visible: false,
        });
    }

    handleKey(e) {
        // Escape key to dismiss
        if (e.key == 'Escape') {
            this.setState({
                visible: false,
            });
        }
        // Toggle with Ctrl-/
        if (e.ctrlKey && e.key == '/') {
            this.setState(state => ({
                visible: !state.visible,
            }));
        }
    }

    render() {
        if (this.state.visible) {
            return (
                <PopoverCard
                    placement="bottom"
                    variations={['admin-user-search']}
                    card={<UserSearchPanel />}
                >
                    {this.renderButton()}
                </PopoverCard>
            );
        } else {
            return this.renderButton();
        }
    }

    renderButton() {
        return (
            <button
                className="admin-bar__item__trigger"
                type="button"
                onClick={e => {
                    e.stopPropagation();
                    this.setState(state => ({
                        visible: !state.visible,
                    }));
                }}
            >
                <span className="admin-bar__item__trigger__icon">
                    <span className="icon icon--search-1" />
                </span>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/AdminBar/UserSearchButton.jsx